import { useQuery } from "@tanstack/react-query";
import { getDisplayedEntities } from "../../../services/rules";
import { displayedEntitiesQueryKey } from "./queryKeys";

// Fetches the displayed-entities list for a specific query (top-level rule or
// sub-query); each query has its own list. Replaces the `setEvent()` event-bus
// hack: mutations now invalidate displayedEntitiesQueryKey(queryId) instead.
export function useDisplayedEntitiesQuery(queryId) {
  return useQuery({
    queryKey: displayedEntitiesQueryKey(queryId),
    queryFn: () => getDisplayedEntities(queryId),
    enabled: Boolean(queryId),
    refetchOnWindowFocus: false,
  });
}
